/**
 * 模块的服务
 * @author ning
 */

// 微信授权和登录
import wechat from './modules/user/wx'
import user from './modules/user'
import user_bnxgn_get from './modules/other/user_bnxgn_get'
import merageAcount from './modules/user/merageAcount'
export const wechatService = wechat
export const userService = user
export const getBNXGNUserService = user_bnxgn_get
// 合并账号
export const acountService = merageAcount
import qw from './modules/user/qw'
export const qwService = qw

// 订单服务
import order from './modules/payment/order'
import address from './modules/payment/address'
import pullnew from './modules/payment/pullnew'
import goodsPrivilege from './modules/payment/goodsPrivilege'
export const orderService = order
export const addressService = address
export const pullnewService = pullnew
export const goodsPrivilegeService = goodsPrivilege
// 分享优惠券
import couponShare from './modules/payment/couponShare'
export const couponShareService = couponShare
// 内容团队
import course from './modules/payment/course'
export const courseService = course
// 练习题服务
import questions from './modules/learn-exercise/questions'
export const questionService = questions

// 分期
import installment from './modules/payment-installment/installment'
export const installmentService = installment

// 提现
import distributionCash from './modules/distribution/distribution-cash'
export const distributionCashService = distributionCash

// 积分
import integral from './modules/payment/integral'
export const integralService = integral
// 训练营
import trainCamp from './modules/payment/trainCamp'
export const trainCampService = trainCamp
// 物流
import express from './modules/order/express'
export const expressService = express

// 活动
import activity from './modules/payment/activity'
export const activityService = activity

import orderList from './modules/payment/orderList'
export const orderListService = orderList
